import { useCallback, useMemo } from "react";
import { useHistory } from "react-router";
import {
  getChildState,
  getParentState,
  ParentState,
  PriceFreezeState,
  useCheckoutState,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BLoadingPopup, ErrorModal } from "@hopper-b2b/ui";

import Error from "../../../assets/client/error.svg";
import { PATH_FLIGHTS_SEARCH } from "../../../utils/urlPaths";
import type { TEvent } from "../events";
import type { FlightMachineContext } from "../types";

const ConnectedLoadingScreen = (props) => {
  const [state] = useCheckoutState<TEvent, FlightMachineContext>();
  const parentState = getParentState(state.value);
  const childState = getChildState(state.value);

  const { t } = useI18nContext();
  const getMessage = useCallback(() => {
    switch (parentState) {
      case ParentState.loading:
      case ParentState.priceFreeze:
      case ParentState.cancelForAnyReason:
      case ParentState.priceFreezeDiscount:
      case ParentState.disruption:
        return t("loading");
      default:
        return "";
    }
  }, [t]);

  const history = useHistory();
  const searchAgain = () => {
    history.push(PATH_FLIGHTS_SEARCH);
  };

  const errorState = useMemo(() => {
    //TODO: add error states for loading and cart update when these endpoints fail.
    return childState === PriceFreezeState.error;
  }, [childState]);
  return errorState ? (
    // TODO: add correct errors for scenarios
    <ErrorModal
      open={errorState}
      title={t("checkoutError.genericErrorTitle")}
      subtitle={t("checkoutError.genericErrorSubtitle")}
      primaryButtonText={t("checkoutError.searchAgain")}
      primaryOnClick={searchAgain}
      image={Error}
    />
  ) : (
    <B2BLoadingPopup
      {...props}
      open
      fullScreen
      message={getMessage()}
      popupSize={"mobile"}
    />
  );
};

export { ConnectedLoadingScreen as LoadingScreen };
